/*
campaignParams is function can be use everytime we are asked to set an input value based on
a parameter contained in a campaign query string (URL).
*/
export const campaignParams = (lookingFor, querystring = window.location.search) => {
    const params = new URLSearchParams(querystring); // params object will always be created, even if querystring is ''
    return params.get(lookingFor) || ''; // params.get returns the param or null
};
//# sourceMappingURL=campaign-data.js.map